import './i18n';
import './index.scss';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { sfsService } from './app-interfaces/sfs-service';
import { store } from './app/store';
import App from './App';
import React, { StrictMode } from 'react';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root')!;
const root = createRoot(container);

sfsService.initialize();

root.render(
    <StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
